// ##############################
// // // ChartCard styles
// #############################

import {
    card,
    cardHeader,
    defaultFont,
    orangeCardHeader,
    greenCardHeader,
    redCardHeader,
    blueCardHeader,
    purpleCardHeader,
    roseCardHeader,
    cardActions,
    grayColor,
    warningColor,
    dangerColor,
    successColor,
    infoColor,
    primaryColor,
    roseColor,
    boxShadow,
} from 'Constants';

export const chartCardStyle = {
    card,
    cardHeader: {
        ...cardHeader,
        padding: '0',
        minHeight: '160px',
        ...defaultFont,
        position: 'relative',
        zIndex: 3,
        transition: 'all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)',
        transform: 'translate3d(0, 0, 0)',
    },
    orangeCardHeader,
    greenCardHeader,
    redCardHeader,
    blueCardHeader,
    purpleCardHeader,
    roseCardHeader,
    cardContent: {
        padding: '15px 20px',
        position: 'relative',
    },
    cardTitle: {
        marginTop: '0',
        marginBottom: '5px',
        ...defaultFont,
        fontSize: '1.175em',
    },
    cardCategory: {
        marginBottom: '0',
        color: grayColor,
        ...defaultFont,
        fontSize: '0.9em',
    },
    cardActions: {
        ...cardActions,
        padding: '10px 0 0 0!important',
    },
    cardStats: {
        lineHeight: '22px',
        color: grayColor,
        fontSize: '12px',
        display: 'inline-block',
        margin: '0!important',
    },
    cardStatsIcon: {
        position: 'relative',
        top: '4px',
        width: '16px',
        height: '16px',
    },
    warningCardStatsIcon: {
        color: warningColor,
    },
    primaryCardStatsIcon: {
        color: primaryColor,
    },
    dangerCardStatsIcon: {
        color: dangerColor,
    },
    successCardStatsIcon: {
        color: successColor,
    },
    infoCardStatsIcon: {
        color: infoColor,
    },
    roseCardStatsIcon: {
        color: roseColor,
    },
    grayCardStatsIcon: {
        color: grayColor,
    },
    cardStatsLink: {
        color: primaryColor,
        textDecoration: 'none',
        ...defaultFont
    },
    underChart: {
        position: 'absolute',
        zIndex: '1',
        top: '-50px',
        width: 'calc(100% - 30px)',
        left: '17px',
        right: '17px',
        textAlign: 'center',
    },
    moveChartUp: {
        transform: 'translate3d(0, -50px, 0)',
    },
};

export const fullHeaderCardStyle = {
    card,
    cardPlain: {
        background: 'transparent',
        boxShadow: 'none',
    },
    cardHeader: {
        ...cardHeader,
        ...defaultFont
    },
    cardPlainHeader: {
        marginLeft: 0,
        marginRight: 0,
    },
    orangeCardHeader,
    greenCardHeader,
    redCardHeader,
    blueCardHeader,
    purpleCardHeader,
    roseCardHeader,
    cardTitle: {
        color: '#FFFFFF',
        marginTop: '0',
        marginBottom: '5px',
        ...defaultFont,
        fontSize: '1.125em',
    },
    cardSubtitle: {},
    cardActions: {
        padding: '14px',
        display: 'block',
        height: 'auto',
    },
    cardContent: {
        padding: '15px 20px',
        position: 'relative',
    },
};

export const headerCardStyle = {
    card,
    cardPlain: {
        background: 'transparent',
        boxShadow: 'none',
    },
    cardHeader: {
        ...cardHeader,
        ...defaultFont,
        display: 'inline-block',
    },
    cardPlainHeader: {
        marginLeft: 0,
        marginRight: 0,
    },
    orangeCardHeader,
    greenCardHeader,
    redCardHeader,
    blueCardHeader,
    purpleCardHeader,
    roseCardHeader,
    cardTitle: {
        color: '#FFFFFF',
        marginTop: '0',
        marginBottom: '3px',
        ...defaultFont,
        fontSize: '1.3em',
    },
    cardSubtitle: {
        marginBottom: '0',
        color: 'red',
        fontSize: '14px',
    },
    cardActions: {
        padding: '14px',
        display: 'block',
        height: 'auto',
    },
    cardContent: {
        padding: '15px 20px',
        position: 'relative',
    },
    left: {
        textAlign: 'left',
    },
    right: {
        textAlign: 'right',
    },
    center: {
        textAlign: 'center',
    },
};

export const iconCardStyle = {
    card,
    cardPlain: {
        background: 'transparent',
        boxShadow: 'none',
    },
    cardHeader: {
        ...cardHeader,
        float: 'left',
    },
    orangeCardHeader,
    greenCardHeader,
    redCardHeader,
    blueCardHeader,
    purpleCardHeader,
    roseCardHeader,
    cardContent: {
        padding: '15px 20px',
        position: 'relative',
    },
    cardAvatar: {
        margin: '0px',
    },
    cardIcon: {
        paddingTop: '3px',
        paddingLeft: '4px',
        paddingRight: '5px',
        color: '#FFFFFF',
        width: '33px',
        height: '27px',
    },
    cardTitle: {
        paddingBottom: '15px',
        marginTop: '0',
        marginBottom: '3px',
        color: '#3C4858',
        textDecoration: 'none',
    },
    cardCategory: {
        color: '#999999',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '1',
        marginBottom: '0',
    },
    cardFooter: {
        margin: '0 20px 10px',
        paddingTop: '10px',
        borderTop: '1px solid #eeeeee',
    },
};

export const imagePriceCardStyle = {
    card,
    cardHeader: {
        ...cardHeader,
        padding: '0',
        ...defaultFont,
        position: 'relative',
        zIndex: 3,
        transition: 'all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)',
        transform: 'translate3d(0, 0, 0)',
        height: '60%',
        overflow: 'hidden',
        marginLeft: '15px',
        marginRight: '15px',
        marginTop: '-30px',
        borderRadius: '6px',
        ...boxShadow
    },
    underImage: {
        position: 'absolute',
        zIndex: '1',
        top: '-50px',
        width: 'calc(100% - 30px)',
        left: '17px',
        right: '17px',
        textAlign: 'center',
    },
    moveImageUp: {
        transform: 'translate3d(0, -50px, 0)',
    },
    cardImage: {
        width: '100%',
        height: '100%',
        borderRadius: '6px',
        pointerEvents: 'none',
        verticalAlign: 'middle',
    },
    cardContent: {
        padding: '15px 20px',
        position: 'relative',
    },
    cardTitle: {
        marginTop: '0',
        marginBottom: '5px',
        ...defaultFont,
        fontSize: '1.175em',
        textAlign: 'center',
    },
    cardCategory: {
        marginBottom: '0',
        color: grayColor,
        ...defaultFont,
        fontSize: '0.9em',
        textAlign: 'center',
    },
    cardActions: {
        ...cardActions,
        padding: '10px 0 0 0!important',
    },
    cardPrice: {
        display: 'inline-block',
        margin: '0!important',
    },
    cardPriceText: {
        margin: '5px 0',
    },
    cardStats: {
        lineHeight: '22px',
        color: grayColor,
        fontSize: '12px',
        display: 'inline-block',
        marginRight: '0',
        marginLeft: 'auto',
    },
    cardStatsIcon: {
        position: 'relative',
        top: '4px',
        width: '16px',
        height: '16px',
    },
    warningCardStatsIcon: {
        color: warningColor,
    },
    primaryCardStatsIcon: {
        color: primaryColor,
    },
    dangerCardStatsIcon: {
        color: dangerColor,
    },
    successCardStatsIcon: {
        color: successColor,
    },
    infoCardStatsIcon: {
        color: infoColor,
    },
    roseCardStatsIcon: {
        color: roseColor,
    },
    grayCardStatsIcon: {
        color: grayColor,
    },
    cardStatsLink: {
        color: primaryColor,
        textDecoration: 'none',
        ...defaultFont
    },
    link: {
        margin: '0 !important',
        padding: '0 !important',
    },
};

export const loginCardStyle = {
    card: {
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
        paddingBottom: '0',
        transform: 'translate3d(0, 0, 0)',
        transition: 'all 300ms linear',
    },
    cardPlain: {
        background: 'transparent',
        boxShadow: 'none',
    },
    cardHeader: {
        background: 'none!important',
        boxShadow: 'none!important',
        textAlign: 'center',
        marginTop: '0',
        marginBottom: '0',

    },
    cardPlainHeader: {
        marginLeft: 0,
        marginRight: 0,
    },
    orangeCardHeader,
    greenCardHeader,
    redCardHeader,
    blueCardHeader,
    purpleCardHeader,
    roseCardHeader,
    cardTitle: {
        ...defaultFont,
        color: 'black',
        marginTop: '0',
        marginBottom: '10px',
        fontWeight: '900',
        fontSize: '1.6em',
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    cardSubtitle: {
        ...defaultFont,
        textAlign: 'center',
        fontSize: '15px',
        marginBottom:'0'
    },
    cardActions: {
        padding: '0',
        display: 'block',
        height: 'auto',
        background:'red',
    },
    cardContent: {
        padding: '0px 24px 24px!important',
        position: 'relative',
    },
    inputAdornmentIcon: {
        color: '#555',
    },
    left: {
        textAlign: 'left',
    },
    right: {
        textAlign: 'right',
    },
    center: {
        textAlign: 'center',
    },
    inpLogin: {
        margin: '0!important'
    }
};

export const pricingCardStyle = {
    card: {
        ...card,
        textAlign: 'center',
        boxShadow:
            '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    },
    cardPlain: {
        background: 'transparent',
        boxShadow: 'none',
    },
    cardContent: {
        padding: '15px 20px !important',
        position: 'relative',
    },
    cardTitle: {
        marginBottom: '0',
        marginTop: '10px',
        color: '#999999',
        fontSize: '14px',
    },
    cardPrice: {
        marginTop: '30px',
        marginBottom: '3px',
        color: '#3C4858',
    },
    cardDescription: {
        color: '#999999',
        fontSize: '14px',
    },
    primary: {
        color: primaryColor,
    },
    warning: {
        color: warningColor,
    },
    danger: {
        color: dangerColor,
    },
    success: {
        color: successColor,
    },
    info: {
        color: infoColor,
    },
    rose: {
        color: roseColor,
    },
    gray: {
        color: grayColor,
    },
    white: {
        color: '#FFFFFF',
    },
    iconWrapper: {
        margin: '10px auto 0px',
        fontSize: '55px',
        border: '1px solid #E5E5E5',
        borderRadius: '50%',
        width: '130px',
        lineHeight: '130px',
        height: '130px',
    },
    iconWrapperOnPlain: {
        border: '1px solid #FFFFFF',
    },
    icon: {
        width: '55px',
        height: '55px',
        top: '6px',
        position: 'relative',
    },
};

export const profileCardStyle = {
    card: {
        marginTop: '30px',
        textAlign: 'center',
        ...card
    },
    cardHeader: {
        display: 'inline-block',
        width: '100%',
        padding: '0px',
    },
    cardAvatar: {
        maxWidth: '130px',
        maxHeight: '130px',
        margin: '-50px auto 0',
        borderRadius: '50%',
        overflow: 'hidden',
        ...boxShadow
    },
    img: {
        width: '100%',
        height: 'auto',
        verticalAlign: 'middle',
        border: '0',
    },
    textAlign: {
        textAlign: 'center',
    },
    cardSubtitle: {
        color: grayColor,
        ...defaultFont,
        fontSize: '14px',
        textTransform: 'uppercase',
        marginTop: '10px',
    },
    cardTitle: {
        ...defaultFont,
        fontSize: '18px',
        marginBottom: '3px',
    },
    cardDescription: {
        ...defaultFont,
        color: '#999999',
        fontSize: '14px',
        margin: '0 0 10px',
    },
    cardActions: {
        height: 'auto',
        display: 'inline',
    },
    cardContent: {
        padding: '15px 20px !important',
        position: 'relative',
    },
    cardFooter: {
        margin: '0 20px 10px',
        paddingTop: '10px',
        borderTop: '1px solid #eeeeee',
    },
};

export const regularCardStyle = {
    card,
    cardPlain: {
        background: 'transparent',
        boxShadow: 'none',
    },
    cardHeader: {
        padding: '15px 20px 0',
        zIndex: '3',
    },
    cardTitle: {
        ...defaultFont,
        color: '#3C4858',
        textDecoration: 'none',
        marginTop: '0',
        marginBottom: '3px',
        fontSize: '1.3em',
        '& small': {
            fontWeight: '400',
            lineHeight: '1',
            color: '#777',
        },
    },
    right: {
        textAlign: 'right',
    },
    left: {
        textAlign: 'left',
    },
    center: {
        textAlign: 'center',
    },
    cardSubtitle: {
        ...defaultFont,
        color: '#999999',
        fontSize: '14px',
        margin: '0 0 10px',
    },
    cardContent: {
        padding: '15px 20px !important',
        position: 'relative',
    },
};

export const statsCardStyle = {
    card,
    cardHeader: {
        ...cardHeader,
        float: 'left',
        textAlign: 'center',
    },
    orangeCardHeader,
    greenCardHeader,
    redCardHeader,
    blueCardHeader,
    purpleCardHeader,
    cardContent: {
        textAlign: 'right',
        paddingTop: '10px',
        padding: '15px 20px',
    },
    cardIcon: {
        width: '40px',
        height: '36px',
        fill: '#fff',
    },
    cardAvatar: {
        margin: '10px 8px 10px',
        display: 'flex',
    },
    cardCategory: {
        marginBottom: '0',
        color: grayColor,
        margin: '0 0 10px',
        ...defaultFont
    },
    cardTitle: {
        margin: '0',
        ...defaultFont,
        fontSize: '1.825em',
    },
    cardTitleSmall: {
        fontSize: '65%',
        fontWeight: '400',
        lineHeight: '1',
        color: '#777',
    },
    cardActions: {
        ...cardActions,
        padding: '10px 0 0 0!important',
    },
    cardStats: {
        lineHeight: '22px',
        color: grayColor,
        fontSize: '12px',
        display: 'inline-block',
        margin: '0!important',
    },
    cardStatsIcon: {
        position: 'relative',
        top: '4px',
        width: '16px',
        height: '16px',
    },
    warningCardStatsIcon: {
        color: warningColor,
    },
    primaryCardStatsIcon: {
        color: primaryColor,
    },
    dangerCardStatsIcon: {
        color: dangerColor,
    },
    successCardStatsIcon: {
        color: successColor,
    },
    infoCardStatsIcon: {
        color: infoColor,
    },
    roseCardStatsIcon: {
        color: roseColor,
    },
    grayCardStatsIcon: {
        color: grayColor,
    },
    cardStatsLink: {
        color: primaryColor,
        textDecoration: 'none',
        ...defaultFont
    },
};

export const tasksCardStyle = theme => ({
    card,
    cardHeader: {
        flex: 'none',
        ...cardHeader,
        ...defaultFont
    },
    cardHeaderRTL: {
        display: 'block',
        '&:after,&:before': {
            display: 'table',
            content: '" "',
        },
        '&:after': {
            boxSizing: 'border-box',
        },
    },
    orangeCardHeader,
    greenCardHeader,
    redCardHeader,
    blueCardHeader,
    purpleCardHeader,
    roseCardHeader,
    cardTitle: {
        ...defaultFont,
        float: 'left',
        padding: '10px 10px 10px 0',
        lineHeight: '24px',
        fontSize: '14px',
        color: '#FFFFFF',
    },
    cardTitleRTL: {
        float: 'right',
        padding: '10px 0px 10px 10px !important',
    },
    tabWrapper: {
        width: 'auto',
        display: 'inline-flex',
        alignItems: 'inherit',
        flexDirection: 'row',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
        },
    },
    tabWrapperRTL: {
        display: 'block',
    },
    tabIcon: {
        float: 'left',
        [theme.breakpoints.down('sm')]: {
            marginTop: '-2px',
        },
    },
    tabIconRTL: {
        float: 'right',
        top: '2px',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            marginRight: '14px',
            top: '5px',
        },
    },
    displayNone: {
        display: 'none',
    },
    labelContainerRTL: {
        float: 'right',
        paddingRight: '10px',
        paddingLeft: '14px',
    },
    labelIcon: {
        height: '44px',
        width: '110px',
        minWidth: '72px',
        paddingLeft: '14px',
        borderRadius: '3px',
    },
    labelIconRTL: {
        paddingLeft: '0px',
        paddingRight: '0px',
    },
    tabsContainer: {
        marginTop: '4px',
        color: '#FFFFFF',
        display: 'flex',
        flexWrap: 'wrap',
    },
    tabsContainerRTL: {
        float: 'right',
    },
    tabs: {
        width: '110px',
        minWidth: '70px',
        paddingLeft: '12px',
    },
    cardHeaderContent: {
        flex: 'none',
    },
    label: {
        lineHeight: '19px',
        textTransform: 'uppercase',
        fontSize: '12px',
        fontWeight: '500',
        marginLeft: '-10px',
    },
    textColorInheritSelected: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        transition: 'background-color .4s',
    },
});

export const testimonialCardStyle = {
    card: {
        ...card,
        marginBottom: '65px',
        marginTop: '30px',
        textAlign: 'center',
    },
    iconWrapper: {
        marginTop: '30px',
    },
    icon: {
        width: '40px',
        height: '40px',
    },
    cardContent: {
        padding: '15px 20px',
        position: 'relative',
    },
    cardDescription: {
        fontStyle: 'italic',
        color: '#999999',
    },
    footer: {
        marginTop: '0',
    },
    cardTitle: {
        marginTop: '0',
        marginBottom: '3px',
        color: '#3C4858',
        textDecoration: 'none',
    },
    cardCategory: {
        color: '#999999',
        fontSize: '14px',
        margin: '10px 0',
    },
    cardAvatar: {
        marginTop: '10px',
        marginBottom: '-50px',
        maxWidth: '100px',
        maxHeight: '100px',
        margin: '-50px auto 0',
        borderRadius: '50%',
        overflow: 'hidden',
        boxShadow:
            '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    },
    img: {
        width: '100%',
        height: 'auto',
        verticalAlign: 'middle',
        border: '0',
    },
};



// WEBPACK FOOTER //
// ./src/common/Cards/styles.jsx